export function isPromiseLike<T>(
  possiblePromise: any
): possiblePromise is PromiseLike<T> {
  return possiblePromise && typeof possiblePromise.then === "function";
}
